import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import CircuitExercisesPanel from "@/pages/admin/CircuitExercisesPanel";

/**
 * Standalone page wrapper for the Circuit Exercises manager. The manager itself lives in
 * CircuitExercisesPanel so it can also be embedded in the Cue Library (one unified area).
 */
export default function RoninExercises() {
  return (
    <div className="min-h-screen bg-[#050505] text-white">
      <div className="border-b border-[#27272A] px-6 py-4 flex items-center gap-3">
        <Link to="/admin/ronin-box" className="text-zinc-400 hover:text-white transition-colors" data-testid="back-to-ronin-admin">
          <ArrowLeft className="h-5 w-5" />
        </Link>
        <div>
          <p className="text-[10px] uppercase tracking-[0.3em] text-[#FF331F] font-bold">Ronin Box</p>
          <h1 className="font-display text-2xl uppercase tracking-tight">Circuit Exercises</h1>
        </div>
      </div>
      <div className="p-6 max-w-2xl mx-auto">
        <CircuitExercisesPanel />
      </div>
    </div>
  );
}
